import {XauditModel} from '../../../models/xaudit.model';
import {OperatoryDataModel} from "../../../models/clients/operatory-data.model";
import { EnumValidValueItemModel } from 'src/app/models/enum/enum-valid-value-item.model';

export class AppointmentDataModel extends XauditModel{
// reduced optimised model for scheduler landing page

    AppointmentId: string;
    LOCID: number;

    isReservation: boolean = false;
    Reservation_AppointmentId: string;

    isBlocked: boolean = false;
    enumApptTypeId: string;
    enumApptStatusId: string;
    ApptStatus: string;
    isFirstVisit: boolean = false;
    PatientId: string;
    OperatoryId: string;
    secondaryOperatorys: string[] = [];

    PatientName: string;
    ProviderDoctor: string ="";

    ReferringDoctor: string ="";
    LocationName: string ="";

    Label_DoctorId: string;

    Subject: string ="";
    Description: string ="";
    startDate: string;
    endDate: string;
    parsedStartDate: Date;
    parsedEndDate: Date ;

    isExistingCase: boolean = false;
    PatientCaseId: string;
    CaseWorkItemId: string;

    CaseProcedureId: string;
    ApptReasonId: string;
    ApptReasonDescription: string;
    ForProcedure: string ="";
    ApptFlags: string;
    PatientFlags: string;
    ProviderDoctor_BackColor: string;
    ProviderDoctor_ForeColor: string;
    AppointmentType_BackColor: string;
    AppointmentType_ForeColor: string;
    AppointmentReason_BackColor: string;
    AppointmentReason_ForeColor: string;
    AppointmentStatus_BackColor: string;
    AppointmentStatus_ForeColor: string;
    LabelLine1: string;
    LabelTooltip: string;
    parentAppointmentId: string;
    dataAppoitmentDetails: AppoitmentDetaileModel[] = [];
    PatientFullInfo: string;
    AppointmentFlagsEnums: EnumValidValueItemModel[]=[];
    PatientFlagsEnums: EnumValidValueItemModel[]=[];
    isBlockTime: boolean = false;
}

export class AppoitmentDetaileModel {
    AppointmentId: string;
    AppointmentDetailId: string;
    DetailParameterName: string;
    DetailParameterValue: string;
}


export class AppointmentStyleModel {
    wType: number ;
    NonWorkingDay: Date;
    RecurringDays: string;
    OperatoryID: string;
    DOW: number; 
    StartTime: Date; 
    EndTime: Date; 
    Reason: string ;
    TDOcolor: string ;
    LOCID: number;
}

export class  AppointmentReason extends XauditModel { 
    ApptReasonId: string;
    Description: string;
    ApptLengthInMinutes: string;
    CaseProcedureId: string;
    ColorSchemeID: string;
    ItemOrder: number;
     
  
  }


export class xDataAppointmentModel extends XauditModel{
    AppointmentId: string;
    LOCID: number;
    enumApptTypeId: string;
    enumApptStatusId: string;
    PatientId: string;
    OperatoryId: string;
    Label_DoctorId: string;
    Subject: string;
    Description: string;
    startDate: string;
    endDate: string ;
    parsedStartDate: Date;
    parsedEndDate: Date ;

    Duration: number;
    isAllDay: boolean;
    isFirstVisit: boolean;
    CaseProcedureId: string;
    isExistingCase: boolean;
    PatientCaseId: string;
    CaseWorkItemId: string;
    NoteGroupId: string; // do not use
    ReminderInfo: string;
    RecurrenceInfo: string;
    isReservation: boolean;
    isPastedReschedule: boolean;
    // Front end only
    CaseWorkItemFormsId: string;
    PatientFullInfo: string;
    smsMessage: string = '';
    isDuplicateForSecondaryOps = false;
    parentAppointmentId: string;
    text: string;
}
